// Temporary fix for hiding the E-list field on the 'Read more' section on SPP reviews.
(function ($) {
  Drupal.behaviors.sdSppReviewsV1 = {
    attached: false,
    attach: function () {
      if (this.attached) {
        return;
      }
      this.attached = true;

      $('.js-product-reviews').on('click', '.pr-accordion-btn', function () {
        $('.pr-rd-def-list').each(function () {
          if ($(this).text().indexOf('E-List') !== -1) {
            $(this).hide();
          }
        });
      });
    }
  };
})(jQuery);
